import { Pipe, PipeTransform } from '@angular/core';
import { Maybe, Product, Scalars, WallDecorPieceForDisplay } from './graphql';
import { Observable, of } from 'rxjs';
import { LookBookPriceRounding } from '../../../../../../photographer-panel/src/graphql';
import { WallDecorPriceCalculatorService } from './wall-decor-price-calculator.service';
import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { map, switchMap } from 'rxjs/operators';
import { LookBookPriceWithFilesCalculatorService } from '@ui/products/shopping-cart-back/pipe/lookbook/look-book-price-with-files-calculator.service';
import { ShoppingCartState } from '@ui/products/shopping-cart-back/actions/standalone';
import { select, Store } from '@ngrx/store';
import { selectLookBookProductsInBasket } from '@ui/products/shopping-cart-back/actions/selector';

@Pipe({
    name: 'calcWallDecorScenePrice',
    standalone: false
})
export class CalcWallDecorScenePricePipe implements PipeTransform {
  constructor(
    private wallDecorPriceCalculatorService: WallDecorPriceCalculatorService,
    private lookBookPriceWithFilesCalculatorService: LookBookPriceWithFilesCalculatorService,
    private store: Store<{ shoppingCart: ShoppingCartState }>,
  ) {}

  transform(
    value: WallDecorPieceForDisplay[],
    config: {
      zalamoStandaloneWallDecor: Maybe<
        Omit<Product, 'taxConfig' | 'hasTaxConfig'>
      >;
      zalamoStandaloneTambour: Maybe<
        Omit<Product, 'taxConfig' | 'hasTaxConfig'>
      >;
      labProducts: Maybe<
        Array<Maybe<Omit<Product, 'taxConfig' | 'hasTaxConfig'>>>
      >;
      labsInPlay: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
    },
    rounding: LookBookPriceRounding,
    preConfig: string,
    usedImagesList: string[],
    lookBookProductConfigId?: string,
  ): Observable<any> {
    if (!config || !value) {
      return of(null);
    }
    console.log(usedImagesList);

    return this.wallDecorPriceCalculatorService
      .calculatePrice(value, config, rounding, preConfig)
      .pipe(
        switchMap((price) =>
          this.store.pipe(
            select(selectLookBookProductsInBasket),
            map((products) => ({
              index: products.find(
                (product) =>
                  product?.lookBookProductConfigId === lookBookProductConfigId,
              )
                ? products.findIndex(
                    (product) =>
                      product?.lookBookProductConfigId ===
                      lookBookProductConfigId,
                  )
                : products.length,
              price,
            })),
          ),
        ),
        switchMap(({ index, price }) =>
          this.lookBookPriceWithFilesCalculatorService.calculatePriceForLookBookProduct(
            {
              price: {
                min: [{ price, code: 'PLN' }],
                max: [{ price, code: 'PLN' }],
              },
              photoIdList: usedImagesList.filter((v, i) => i < value.length),
              quantity: 1,
              timeAddedToShoppingCart: 0,
            },
            index,
            true,
          ),
        ),
        map((price) =>
          formatCurrency(
            price[0].price,
            'pl',
            getCurrencySymbol('PLN', 'narrow'),
          ),
        ),
      );
  }
}
